<!-- eslint-disable vue/require-v-for-key -->
<template>
<div class="chat">
   <el-container style="z-index:1">
    <el-main style="overflow: hidden">
      <div class="morpheusFirst">
        <div class="message" style="overflow:auto;">
          <el-scrollbar ref="myScrollbar">
            <div style="text-align: left;margin-top:15px;display: inline-block;width:100%">
                <div style="display: flex; float:left;margin-top:15px; width:100%;">
                  <div style="width:100%;
                              backdrop-filter: blur(22.96px);
                              border-radius: 10px;
                              white-space: pre-line;
                              margin-bottom:15px;
                              padding-bottom: 20px;
                              box-sizing: border-box;
                              background: rgb(255, 255, 255);
                              border: 1px solid rgb(6, 46, 155);
                              box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.19);
                              border-radius:25px;
                              ">
                    <div style="color: rgb(6, 46, 155);
                              font-family: Montserrat;
                              font-size: 20px;
                              margin-top:-15px;
                              font-weight: 500;
                              margin-left:10px;
                              display: flex;"
                              >
                     <img style="margin-top:1rem;width:71px;height:60px;margin-right:2px" src="../../assets/images/morpheusb.png" alt="">
                    {{'My name is Morpheus, a Large Language Model developed by Matrix AI Network.'}}
                    </div>
                    <div style="color: rgb(6, 46, 155);
                              font-family: Montserrat;
                              font-size: 20px;
                              margin-top:-15px;
                              font-weight: 500;
                              margin-left:80px;
                              display: flex;">
                    {{'Don\'t know where to start? You can try saying:'}}
                    </div>
                    <div style="color: rgb(6, 46, 155);
                              font-family: Montserrat;
                              font-size: 20px;
                              margin-top:-15px;
                              font-weight: 500;
                              margin-left:56px;
                              display: flex;">
                      <img style="margin-top:2rem;width:24px;height:20px;margin-right:2px" src="../../assets/images/mess.png" alt="">
                      {{'Can you explain the concept of neural networks?'}}
                    </div>
                    <div style="color: rgb(6, 46, 155);
                              font-family: Montserrat;
                              font-size: 20px;
                              margin-top:-15px;
                              font-weight: 500;
                              margin-left:56px;
                              display: flex;">
                      <img style="margin-top:2rem;width:24px;height:20px;margin-right:2px" src="../../assets/images/mess.png" alt="">
                      {{'Tell me a joke.'}}
                    </div>
                    <div style="color: rgb(6, 46, 155);
                              font-family: Montserrat;
                              font-size: 20px;
                              margin-top:-15px;
                              font-weight: 500;
                              margin-left:56px;
                              display: flex;">
                      <img style="margin-top:2rem;width:24px;height:20px;margin-right:2px" src="../../assets/images/mess.png" alt="">
                      {{'Write a poem about AI.'}}
                    </div>
                  </div>
                </div>
            </div>
            <div v-for=" (item,index) in messageList" :key="index">
              <div style="text-align: left;margin-top:15px;width: 100%;display: flex;flex-direction: row;justify-content: flex-end;">
                <div style="float:right;
                            margin-top:15px;
                            width:60%;
                            box-sizing: border-box;
                            background: rgb(255, 255, 255);
                            border: 1px solid rgb(6, 46, 155);
                            box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.19);
                            border-radius:15px;
                            white-space: pre-line;
                            ">
                <p style="color: rgb(6, 46, 155);margin-top:-5px; margin-left:10px; text-align:left">
                {{item.ask}}
                </p>
                </div>
                <div>
                  <img style="width:30px;height:30px;margin-right:2px" src="../../assets/images/mess2.png" alt="">
                </div>
              </div>
              <div style="text-align: left;margin-top:15px;display: inline-block;width:100%">
                <div style="display: flex; float:left;margin-top:15px; width:100%;">
                  <img style="width:30px;height:30px;margin-right:2px" src="../../assets/images/morpheusb.png" alt="">
                  <div v-loading="item.loading" style="
                              width:60%;
                              box-sizing: border-box;
                              background: rgb(255, 255, 255);
                              border: 1px solid rgb(6, 46, 155);
                              box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.19);
                              backdrop-filter: blur(22.96px);
                              border-radius: 15px;
                              white-space: pre-line;
                              margin-bottom:15px;
                              "
                              >
                      <p style="color: rgb(6, 46, 155);margin-top:-5px;margin-left:10px;">
                        {{item.answer}}
                      </p>
                  </div>
                  </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div style="height:30px"></div>
        <div style="display:flex;;margin-bottom: 30px;">
          <el-input style="height:30px;border-radius: 5px;margin-bottom: 30px;margin-left: 10px;"
                  type="textarea"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 3}"
                  placeholder="Please enter your question"
                  @keyup.enter.native="UserSelect($event)"
                  v-model="transferJson">
          </el-input>
          <el-button slot="append" icon="el-icon-my-send" @click="sendmessage(0)" style="background: transparent;border:0ch;padding: 4px;"></el-button>
        </div>
      </div>
    </el-main>
  </el-container>
</div>
</template>

<script>
// import store from '@/store'
import Bus from '@/assets/js/Bus'
import * as storeLocal from 'store'
export default {
  name: 'MyWallet',
  data () {
    return {
      flag: '',
      tips: true,
      loading: false,
      transferJson: '',
      key: '',
      count: 0,
      // messageList: [{ask: '\n你\n好', answer: '\n我\n很好'}]
      messageList: []
    }
  },
  mounted () {
    this.key = storeLocal.get('key')
    Bus.$on('updatekey', (data) => {
      this.key = storeLocal.get('key')
    })
  },
  methods: {
    load () {
      this.count += 2
    },
    closeTips () {
      this.tips = false
    },
    UserSelect (e) {
      if (e.shiftKey && e.key === 'Enter') {
        console.log('shiftKey enter', this.transferJson)
        console.log(e)
      } else {
        console.log(e)
        this.sendmessage(0)
      }
    },
    scrollDown () {
      this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight
    },
    goPage (route) {
      this.$router.push({ path: '/morpheus/' + route })
    },
    sendmessage (example) {
      // console.log('sendmessage', this.transferJson)
      if (this.loading) {
        this.$message({message: 'Just a moment, please！', type: 'warning'})
        return
      }
      let ask = this.transferJson
      if (example === 1) {
        ask = 'Can you explain the concept of neural networks and their role in deep learning?'
      } else if (example === 2) {
        ask = 'Can you explain the difference between machine learning and deep learning?'
      } else if (example === 3) {
        ask = 'Can you tell me the weather forecast for tomorrow in Istanbul?'
      }
      if (ask === '') {
        this.$message({message: 'Please enter your question!', type: 'warning'})
        return
      }
      this.loading = true
      let url = 'https://morpheus.matrix.io/ask'
      // let url = 'http://127.0.0.1:5000/ask'
      this.transferJson = ''
      // if (this.flag === '') {
      //   this.messageList[0].ask = ask
      //   this.messageList[0].answer = ''
      //   this.messageList[0].loading = true
      //   this.flag = 'flag'
      // } else {
      this.messageList.push({ask: ask, answer: '', loading: true})
      // }
      // this.$http.post(url, {'prompt': 'Human::' + ask + '\nAI:'}, {
      this.$http.post(url, {'Key': this.key, 'Question': ask}, {
        emulateJSON: true
      }).then(result => {
        console.log('result', result)
        let answer = ''
        if (result.data.code < 0) {
          answer = result.data.message
        } else {
          if (result.data.data[0] === '\n') {
            answer = result.data.data.slice(1)
          } else {
            answer = result.data.data.replace(/\\n/g, '\n')
          }
        }
        let listlength = this.messageList.length
        this.messageList[listlength - 1].loading = false
        this.messageList[listlength - 1].answer = answer
        console.log('messagelist', this.messageList)
        this.loading = false
      }).catch(_err => {
        console.log('err', _err)
        let listlength = this.messageList.length
        this.messageList[listlength - 1].loading = false
        this.messageList[listlength - 1].answer = 'Something has gone wrong, please try again.'
        this.loading = false
      })
    }
  },
  components: {
  },
  updated: function () {
    this.scrollDown()
  }
}
</script>

<style scoped lang="less">
.chat{
   .el-container {
    height: 100vh;
  }
   .el-main {
    padding: 1rem 2rem 2.5rem;
    margin:1rem;
    margin-left: 0rem;
    margin-bottom: 2rem;
    border-radius: 40px;
    background: #E8ECF4;
    justify-content: center;
    text-align: -webkit-center;
    text-align: -moz-center;
  }
  .morpheusFirst {
    /deep/.el-scrollbar__bar.is-vertical{
      opacity: 1;
    }
    /deep/.el-container {
      height: 100vh;
      /deep/.el-main {
        height: 100vh;
      background: #E8ECF4;
      // padding: 4.5rem 0 2.5rem 0;
      justify-content: center;
      text-align: -webkit-center;
      text-align: -moz-center;
      }
    }
    height: 100vh;
    width: 100%;
    .message{
      border-radius: 10px;
      // background: linear-gradient(rgba(255,255,255,0.15) 0%,rgba(255,255,255,0.05) 100%);
      height:78vh;
      padding-left: 10px;
      padding-right: 10px;
      // overflow: hidden;
    }
    .keyStoneHintFont {
      font-size: 0.75rem;
      color: #9298ae;
      letter-spacing: 0.11px;
      text-align: center;
    }
    a {
      font-size: 12px;
      color: #1c51dd;
      letter-spacing: 0.11px;
      text-align: center;
      line-height: 17px;
      cursor: pointer;
    }
    /deep/.el-icon-my-send{
      background: url('../../assets/images/sendd.png') no-repeat;
      font-size: 16px;
      width: 60px;
      height: 60px;
      background-size: cover;
    }
    /deep/.el-icon-my-send:before{
      font-size: 16px;
    }
    /deep/.el-textarea__inner{
      width: 100%;
      height: 60px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(6, 46, 155);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      border-radius:15px;
    }
    /deep/.el-input-group__append {
      background: transparent;
      border: 0px;
    }
    /deep/.el-loading-spinner .circular {
      width: 20px;
    }
    /deep/.el-loading-mask{
      background-color: rgba(255,255,255,.0);
    }
    // /deep/.el-scrollbar__wrap{
    //   overflow-x: hidden;
    //   overflow: scroll;
    //   height: 100%;
    //   -webkit-overflow-scrolling: touch;
    // }
  }
  @media (max-width: 992px){
    .el-container{
        height: auto;
        display: block;
    }
    .el-card__body, .el-main {
    padding: 0;
    }
    .el-card.is-always-shadow {
    margin: 0 auto !important;
    width: 100% !important;
    height: auto !important;
    }
    .el-container>div {
    width: 100% !important;
    padding: 0 !important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Morpheus/Chat.vue